//Built-in libraries
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';

//Custom components

//Services

//Assets and Miscellaneous

type NeighborhoodInfoType = {
  neighborhood: string;
  _count: string;
  projectsValues: string;
};

interface NeighborhoodImpactWidgetProps {
  data: NeighborhoodInfoType[];
}

const NeighborhoodImpactWidget = ({ data }: NeighborhoodImpactWidgetProps) => {
  return (
    <div className='relative h-full w-full min-w-0'>
      <div className='h-full w-full min-w-0'>
        <div className='flex flex-row bg-white justify-start items-center rounded-t-md py-4'>
          <h3 className='font-bold text-bold border-l-4 p-4 border-green-500 capitalize'>Neighborhood Impact</h3>
          <div className='pr-2 text-neutralColor-light cursor-pointer hover:text-neutralColor-medium transition duration-300 ease-in-out'></div>
        </div>
        <div className='border rounded-b-md w-full bg-white h-96 overflow-x-auto overflow-y-auto'>
          <table className='divide-y divide-gray-200 w-full min-w-[280px]'>
            <thead className='bg-gray-50'>
              <tr>
                <th className='p-4 text-left text-xs text-neutralColor-normal tracking-wider whitespace-nowrap'>Neighborhood Name</th>
                <th className='p-4 text-left text-xs text-neutralColor-normal tracking-wider whitespace-nowrap'>Projects</th>
                <th className='p-4 text-left text-xs text-neutralColor-normal tracking-wider whitespace-nowrap'>Value Of Projects</th>
              </tr>
            </thead>
            <tbody className='bg-white divide-y divide-gray-200'>
              {data?.map((d: NeighborhoodInfoType) => (
                <tr key={d.neighborhood}>
                  <td className='p-4'>{d.neighborhood}</td>
                  <td className='p-4'>{d._count}</td>
                  <td className='p-4'>
                    <CurrencyFormatDisplay value={d.projectsValues} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default NeighborhoodImpactWidget;
